import Fetch from '@/api';
const ACTION_TYPE = {
  ADD_DRUG_INFO: 'addDrugInfo',
  EDIT_DRUG_INFO: 'editDrugInfo',
  UPDATE_DRUG_INFO: 'updateDrugInfo',
  DELETE_DRUG_INFO: 'deleteDrugInfo',
  SELECT_TAG: 'select_tag',
  ADD_TAG: 'addTag',
  REMOVE_TAG: 'removeTag'
};

const CARD_MODE = {
  NEW: 'new',
  UPDATE: 'update',
  SAVE: 'save'
};

const DRUG_MAX_COUNT = 5;

const drugInfoMixin = {
  provide() {
    return {
      [ACTION_TYPE.ADD_DRUG_INFO]: this[ACTION_TYPE.ADD_DRUG_INFO],
      [ACTION_TYPE.EDIT_DRUG_INFO]: this[ACTION_TYPE.EDIT_DRUG_INFO],
      [ACTION_TYPE.UPDATE_DRUG_INFO]: this[ACTION_TYPE.UPDATE_DRUG_INFO],
      [ACTION_TYPE.DELETE_DRUG_INFO]: this[ACTION_TYPE.DELETE_DRUG_INFO]
    };
  },
  data() {
    return {
      showDrugInfoError: false,
      drugInfoList: [],
      drugUsages: [],
      perUnits: [],
      units: [],
      usageFrequencyNames: [],
      drugWarn: {}
    };
  },
  computed: {
    allSave() {
      return this.drugInfoList.every(drug => drug.mode === CARD_MODE.SAVE);
    }
  },
  created() {
    this.fetchDrugOption();
  },
  methods: {
    fetchDrugOption() {
      Fetch.get_drug_option().then(({ drugUsages, perUnits, units, usageFrequencyNames }) => {
        this.drugUsages = drugUsages.map(o => ({
          label: o.name,
          value: o.name,
          children: o.child.map(c => ({ label: c, value: c }))
        }));
        this.perUnits = perUnits.map(o => ({ label: o, value: o }));
        this.units = units.map(o => ({ label: o, value: o }));
        this.usageFrequencyNames = usageFrequencyNames.map(o => ({ label: o, value: o }));
      });
    },
    validDrugInfo(cb) {
      let drugValid =
        this.drugInfoList.length > 0 &&
        this.drugInfoList.filter(drug => drug.mode === CARD_MODE.SAVE).length === this.drugInfoList.length;
      if (!drugValid) {
        if (!this.drugInfoList.length) {
          this.showDrugInfoError = true;
        } else {
          const ids = this.drugInfoList.filter(drug => drug.mode !== CARD_MODE.SAVE).map(o => o.id);
          ids.forEach(id => {
            this.$refs.drugInfo && (this.$refs.drugInfo.$refs[`card${id}`][0].saveError = true);
          });
        }
        return;
      }
      let data = this.drugInfoList.map(
        ({
          drugBarcodeId,
          drugRemarks,
          num,
          drugProductDTOS: [
            { drugId, takingDay, drugUsage, drugBarcodeDTOS, id, companyId, isIntegrity, usageAndDosage, ...rest }
          ]
        }) => ({
          ...rest,
          num,
          dose: takingDay,
          usage: drugUsage,
          drugProductId: id,
          drugBarcodeId,
          remark: drugRemarks
        })
      );
      cb && cb(data);
    },
    [ACTION_TYPE.ADD_DRUG_INFO](info) {
      this.drugInfoList = this.drugInfoList.concat(info);
      this.showDrugInfoError = false;
    },
    [ACTION_TYPE.EDIT_DRUG_INFO](info) {
      this.drugInfoList = this.drugInfoList.map(drug => {
        if (drug.id === info.id) {
          return { ...drug, ...info };
        }
        return drug;
      });
    },
    [ACTION_TYPE.UPDATE_DRUG_INFO](info, callback, isSave = true) {
      if (isSave) {
        Telescope.trackEvent({
          trackId: 'zywzpc-save-drug-modal',
          custom: { name: info.name, drugProductDTOS: info.drugProductDTOS }
        });
        return Fetch.save_drug(info.name, info.drugProductDTOS).then(({ drugProductDTOS }) => {
          if (info.from === CARD_MODE.NEW) {
            Fetch.check_drug(info.name, this.drugInfoList.map(drug => drug.name).filter(Boolean))
              .then((res = {}) => {
                this.drugWarn = (res.drugWarnList || []).reduce((pre, cur) => {
                  pre[cur.drugName] = cur.riskWarnMsg;
                  return pre;
                }, {});
              })
              .then(_ => {
                this.drugInfoList = this.drugInfoList.map(drug => {
                  if (drug.id === info.id) {
                    info.drugProductDTOS[0].id = drugProductDTOS[0].id;
                    info.drugProductDTOS[0].companyId = drugProductDTOS[0].companyId;
                    info.drugBarcodeId = drugProductDTOS[0].drugBarcodeDTOS[0]
                      ? drugProductDTOS[0].drugBarcodeDTOS[0].id
                      : null;
                    return { ...drug, ...info };
                  }
                  return drug;
                });
                // this.fetchDrugTags();
              });
          } else {
            this.drugInfoList = this.drugInfoList.map(drug => {
              if (drug.id === info.id) {
                info.drugProductDTOS[0].id = drugProductDTOS[0].id;
                info.drugProductDTOS[0].companyId = drugProductDTOS[0].companyId;
                return { ...drug, ...info };
              }
              return drug;
            });
          }
          return info.drugProductDTOS[0];
        });
      } else {
        this.drugInfoList = this.drugInfoList.map(drug => {
          if (drug.id === info.id) {
            return { ...drug, ...info };
          }
          return drug;
        });
      }
    },
    [ACTION_TYPE.DELETE_DRUG_INFO](id) {
      this.drugInfoList = this.drugInfoList.filter(drug => drug.id !== id);
      // this.fetchDrugTags();
    }
  }
};

export default drugInfoMixin;
